/**
 * `CandidateItem.name` falls back to the DynamoDB `resumeId` on the backend
 * (`DeepMatchingResultToCandidateItemMapper#mapCandidateItem`) whenever
 * `first_name`/`last_name` are both blank on the source record -- so a
 * candidate the enrichment pipeline never populated a name for renders as
 * its own internal id, e.g. "3866_190075027" (jobId_candidateId).
 *
 * The real fix belongs in that fallback (it should never surface an
 * internal key as a person's name); this is the defensive frontend layer so
 * the page reads correctly regardless of which candidates that backend
 * change has already reached.
 */
const RESUME_ID_SHAPED = /^\S+_\d+$/;

export const displayCandidateName = (name?: string | null): string => {
  if (!name || RESUME_ID_SHAPED.test(name)) return 'Unnamed candidate';
  return name;
};

/**
 * A real job seeker in a test workspace, which the viewer may see in the list
 * but not open (`Candidate.listOnly`). Only an explicit true counts: absent,
 * null or anything else leaves the row as it always was.
 */
export const isListOnly = (candidate: { listOnly?: boolean | null }): boolean =>
  candidate.listOnly === true;
